module.exports = __webpack_public_path__ + "static/img/doc_login.37ea553.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doc_login.png
// module id = gley
// module chunks = 16